var $assign, $coroutine, $debug, $filter, $findIndex, $findWhere, $isArray, $isVmRunning, $js2xml, attachDisk, attachPci, backup, checkPermissionOnSrs, clone, concat, convertToTemplate, copy, create, createCloudInitConfigDrive, createInterface, delete_, deltaCopy, detachPci, ejectCd, endsWith, escapeStringRegexp, eventToPromise, export_, extract, forEach, forbiddenOperation, format, getCloudInitConfig, handleExport, handleVmImport, importBackup, importDeltaBackup, import_, insertCd, invalidParameters, map, mapFilter, mapToArray, merge, migrate, noop, pCatch, pFinally, parseSize, parseXml, recoveryStart, ref, ref1, restart, resume, revert, rollingBackup, rollingDeltaBackup, rollingDrCopy, rollingSnapshot, set, setBootOrder, snapshot, sortBy, start, startsWith, stats, stop, suspend, unauthorized;

$assign = require('lodash/assign');

$debug = (require('debug'))('xo:api:vm');

$filter = require('lodash/filter');

$findIndex = require('lodash/findIndex');

$findWhere = require('lodash/find');

concat = require('lodash/concat');

endsWith = require('lodash/endsWith');

escapeStringRegexp = require('escape-string-regexp');

eventToPromise = require('event-to-promise');

merge = require('lodash/merge');

sortBy = require('lodash/sortBy');

startsWith = require('lodash/startsWith');

$coroutine = require('bluebird').coroutine;

format = require('json-rpc-peer').format;

ref = require('xo-common/api-errors'), forbiddenOperation = ref.forbiddenOperation, invalidParameters = ref.invalidParameters, unauthorized = ref.unauthorized;

ref1 = require('../utils'), forEach = ref1.forEach, $js2xml = ref1.formatXml, $isArray = ref1.isArray, map = ref1.map, mapFilter = ref1.mapFilter, mapToArray = ref1.mapToArray, noop = ref1.noop, parseSize = ref1.parseSize, parseXml = ref1.parseXml, pCatch = ref1.pCatch, pFinally = ref1.pFinally;

$isVmRunning = require('../xapi').isVmRunning;

checkPermissionOnSrs = function(vm, permission) {
  var permissions;
  if (permission == null) {
    permission = 'operate';
  }
  permissions = [];
  forEach(vm.$VBDs, (function(_this) {
    return function(vbdId) {
      var vbd, vdiId;
      vbd = _this.getObject(vbdId, 'VBD');
      vdiId = vbd.VDI;
      if (vbd.is_cd_drive || !vdiId) {
        return;
      }
      return permissions.push([_this.getObject(vdiId, 'VDI').$SR, permission]);
    };
  })(this));
  return this.hasPermissions(this.session.get('user_id'), permissions).then((function(_this) {
    return function(success) {
      if (!success) {
        throw unauthorized();
      }
    };
  })(this));
};

extract = function(obj, prop) {
  var value;
  value = obj[prop];
  delete obj[prop];
  return value;
};

create = $coroutine(function*(params) {
  var $resourceSet, checkLimits, existingVdis, i, installation, len, limits, objectIds, ref2, resourceSet, template, user, vdiSizesByDevice, vdis, vif, vifId, vifs, vm, xapi, xapiVm;
  user = this.user;
  resourceSet = extract(params, 'resourceSet');
  if (!resourceSet && user.permission !== 'admin') {
    throw unauthorized();
  }
  template = extract(params, 'template');
  params.template = template._xapiId;
  xapi = this.getXapi(template);
  objectIds = [template.id];
  limits = {
    cpus: template.CPUs.number,
    disk: 0,
    memory: template.memory.dynamic[1],
    vms: 1
  };
  vdiSizesByDevice = {};
  forEach(xapi.getObject(template._xapiId).$VBDs, (function(_this) {
    return function(vbd) {
      var vdi;
      if (vbd.type === 'Disk' && (vdi = vbd.$VDI)) {
        vdiSizesByDevice[vbd.userdevice] = +vdi.virtual_size;
      }
    };
  })(this));
  vdis = extract(params, 'VDIs');
  params.vdis = vdis && map(vdis, (function(_this) {
    return function(vdi) {
      var ref2, ref3, size, sr;
      sr = _this.getObject(vdi.SR);
      size = parseSize(vdi.size);
      objectIds.push(sr.id);
      limits.disk += size;
      return $assign({}, vdi, {
        device: (ref2 = (ref3 = vdi.userdevice) != null ? ref3 : vdi.device) != null ? ref2 : vdi.position,
        size: size,
        SR: sr._xapiId,
        type: vdi.type
      });
    };
  })(this));
  existingVdis = extract(params, 'existingDisks');
  params.existingVdis = existingVdis && map(existingVdis, (function(_this) {
    return function(vdi, userdevice) {
      var size, sr;
      if (vdi.size != null) {
        size = parseSize(vdi.size);
        vdiSizesByDevice[userdevice] = size;
      }
      if (vdi.$SR) {
        sr = _this.getObject(vdi.$SR);
        objectIds.push(sr.id);
      }
      return $assign({}, vdi, {
        size: size,
        $SR: sr && sr._xapiId
      });
    };
  })(this));
  forEach(vdiSizesByDevice, (function(_this) {
    return function(size) {
      return limits.disk += size;
    };
  })(this));
  vifs = extract(params, 'VIFs');
  params.vifs = vifs && map(vifs, (function(_this) {
    return function(vif) {
      var network;
      network = _this.getObject(vif.network);
      objectIds.push(network.id);
      return {
        mac: vif.mac,
        network: network._xapiId,
        ipv4_allowed: vif.allowedIpv4Addresses,
        ipv6_allowed: vif.allowedIpv6Addresses
      };
    };
  })(this));
  installation = extract(params, 'installation');
  params.installRepository = installation && installation.repository;
  checkLimits = null;
  if (resourceSet) {
    yield this.checkResourceSetConstraints(resourceSet, user.id, objectIds);
    checkLimits = $coroutine((function(_this) {
      return function*(limits2) {
        yield _this.allocateLimitsInResourceSet(limits, resourceSet);
        return (yield _this.allocateLimitsInResourceSet(limits2, resourceSet));
      };
    })(this));
  }
  xapiVm = (yield xapi.createVm(template._xapiId, params, checkLimits));
  vm = xapi.xo.addObject(xapiVm);
  if (resourceSet) {
    yield Promise.all([
      params.share ? ($resourceSet = (yield this.getResourceSet(resourceSet)), Promise.all(map($resourceSet.subjects, (function(_this) {
        return function(subjectId) {
          return _this.addAcl(subjectId, vm.id, 'admin');
        };
      })(this)))) : this.addAcl(user.id, vm.id, 'admin'), xapi.xo.setData(xapiVm.$id, 'resourceSet', resourceSet)
    ]);
  }
  ref2 = vm.VIFs;
  for (i = 0, len = ref2.length; i < len; i++) {
    vifId = ref2[i];
    vif = this.getObject(vifId, 'VIF');
    yield this.allocIpAddresses(vifId, concat(vif.allowedIpv4Addresses, vif.allowedIpv6Addresses))["catch"]((function(_this) {
      return function() {
        return xapi.deleteVif(vif._xapiId);
      };
    })(this));
  }
  if (params.bootAfterCreate) {
    pCatch.call(xapi.startVm(vm._xapiId), noop);
  }
  return vm.id;
});

create.params = {
  affinityHost: {
    type: 'string',
    optional: true
  },
  bootAfterCreate: {
    type: 'boolean',
    optional: true
  },
  cloudConfig: {
    type: 'string',
    optional: true
  },
  coreOs: {
    type: 'boolean',
    optional: true
  },
  clone: {
    type: 'boolean',
    optional: true
  },
  resourceSet: {
    type: 'string',
    optional: true
  },
  installation: {
    type: 'object',
    optional: true,
    properties: {
      method: {
        type: 'string'
      },
      repository: {
        type: 'string'
      }
    }
  },
  name_label: {
    type: 'string'
  },
  name_description: {
    type: 'string',
    optional: true
  },
  pv_args: {
    type: 'string',
    optional: true
  },
  share: {
    type: 'boolean',
    optional: true
  },
  template: {
    type: 'string'
  },
  VIFs: {
    optional: true,
    type: 'array',
    items: {
      type: 'object',
      properties: {
        network: {
          type: 'string'
        },
        mac: {
          optional: true,
          type: 'string'
        },
        allowedIpv4Addresses: {
          optional: true,
          type: 'array',
          items: {
            type: 'string'
          }
        },
        allowedIpv6Addresses: {
          optional: true,
          type: 'array',
          items: {
            type: 'string'
          }
        }
      }
    }
  },
  VDIs: {
    optional: true,
    type: 'array',
    items: {
      type: 'object',
      properties: {
        device: {
          type: 'string'
        },
        size: {
          type: ['integer', 'string']
        },
        SR: {
          type: 'string'
        },
        type: {
          type: 'string'
        }
      }
    }
  },
  existingDisks: {
    optional: true,
    type: 'object',
    items: {
      type: 'object',
      properties: {
        size: {
          type: ['integer', 'string'],
          optional: true
        },
        $SR: {
          type: 'string',
          optional: true
        }
      }
    }
  }
};

create.resolve = {
  template: ['template', 'VM-template', '']
};

exports.create = create;

delete_ = $coroutine(function*(arg) {
  var cpus, deleteDisks, disk, ipPoolsUsage, memory, ref2, resourceSet, resourceSetUsage, vdis, vm, xapi;
  vm = arg.vm, deleteDisks = (ref2 = arg.delete_disks) != null ? ref2 : false;
  cpus = vm.CPUs.number;
  memory = vm.memory.size;
  xapi = this.getXapi(vm);
  this.getAllAcls().then((function(_this) {
    return function(acls) {
      return Promise.all(mapFilter(acls, function(acl) {
        if (acl.object === vm.id) {
          return pCatch.call(_this.removeAcl(acl.subject, acl.object, acl.action), noop);
        }
      }));
    };
  })(this));
  yield Promise.all(map(vm.VIFs, (function(_this) {
    return function(vifId) {
      var vif;
      vif = xapi.getObject(vifId);
      return pCatch.call(_this.allocIpAddresses(vifId, null, concat(vif.ipv4_allowed, vif.ipv6_allowed)), noop);
    };
  })(this)));
  resourceSet = xapi.xo.getData(vm._xapiId, 'resourceSet');
  if (resourceSet != null) {
    disk = 0;
    vdis = {};
    forEach(vm.$VBDs, (function(_this) {
      return function(vbd) {
        var vdi;
        if (vbd.type === 'Disk' && (vdi = vbd.$VDI) && !vdis[vdi.$id]) {
          vdis[vdi.$id] = true;
          disk += +vdi.virtual_size;
        }
      };
    })(this));
    resourceSetUsage = this.computeVmResourcesUsage(vm);
    ipPoolsUsage = (yield this.computeVmIpPoolsUsage(vm));
    pCatch.call(this.releaseLimitsInResourceSet(merge(resourceSetUsage, ipPoolsUsage), resourceSet), noop);
  }
  return xapi.deleteVm(vm._xapiId, deleteDisks);
});

delete_.params = {
  id: {
    type: 'string'
  },
  delete_disks: {
    optional: true,
    type: 'boolean'
  }
};

delete_.resolve = {
  vm: ['id', ['VM', 'VM-snapshot', 'VM-template'], 'administrate']
};

exports["delete"] = delete_;

ejectCd = $coroutine(function*(arg) {
  var vm;
  vm = arg.vm;
  yield this.getXapi(vm).ejectCdFromVm(vm._xapiId);
});

ejectCd.params = {
  id: {
    type: 'string'
  }
};

ejectCd.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.ejectCd = ejectCd;

insertCd = $coroutine(function*(arg) {
  var force, vdi, vm;
  vm = arg.vm, vdi = arg.vdi, force = arg.force;
  yield this.getXapi(vm).insertCdIntoVm(vdi._xapiId, vm._xapiId, {
    force: force
  });
});

insertCd.params = {
  id: {
    type: 'string'
  },
  cd_id: {
    type: 'string'
  },
  force: {
    type: 'boolean'
  }
};

insertCd.resolve = {
  vm: ['id', 'VM', 'operate'],
  vdi: ['cd_id', 'VDI', 'view']
};

exports.insertCd = insertCd;

migrate = $coroutine(function*(arg) {
  var host, mapVdisSrs, mapVdisSrsXapi, mapVifsNetworks, mapVifsNetworksXapi, migrationNetwork, permissions, vm;
  vm = arg.vm, host = arg.host, mapVdisSrs = arg.mapVdisSrs, mapVifsNetworks = arg.mapVifsNetworks, migrationNetwork = arg.migrationNetwork;
  permissions = [];
  if (mapVdisSrs) {
    mapVdisSrsXapi = {};
    forEach(mapVdisSrs, (function(_this) {
      return function(srId, vdiId) {
        var vdiXapiId;
        vdiXapiId = _this.getObject(vdiId, 'VDI')._xapiId;
        mapVdisSrsXapi[vdiXapiId] = _this.getObject(srId, 'SR')._xapiId;
        return permissions.push([srId, 'administrate']);
      };
    })(this));
  }
  if (mapVifsNetworks) {
    mapVifsNetworksXapi = {};
    forEach(mapVifsNetworks, (function(_this) {
      return function(networkId, vifId) {
        var vifXapiId;
        vifXapiId = _this.getObject(vifId, 'VIF')._xapiId;
        mapVifsNetworksXapi[vifXapiId] = _this.getObject(networkId, 'network')._xapiId;
        return permissions.push([networkId, 'administrate']);
      };
    })(this));
  }
  if (!(yield this.hasPermissions(this.session.get('user_id'), permissions))) {
    throw unauthorized();
  }
  yield this.getXapi(vm).migrateVm(vm._xapiId, this.getXapi(host), host._xapiId, {
    migrationNetworkId: migrationNetwork != null ? migrationNetwork._xapiId : void 0,
    mapVifsNetworks: mapVifsNetworksXapi,
    mapVdisSrs: mapVdisSrsXapi
  });
});

migrate.params = {
  vm: {
    type: 'string'
  },
  targetHost: {
    type: 'string'
  },
  mapVdisSrs: {
    type: 'object',
    optional: true
  },
  mapVifsNetworks: {
    type: 'object',
    optional: true
  },
  migrationNetwork: {
    type: 'string',
    optional: true
  }
};

migrate.resolve = {
  vm: ['vm', 'VM', 'administrate'],
  host: ['targetHost', 'host', 'administrate'],
  migrationNetwork: ['migrationNetwork', 'network', 'administrate']
};

exports.migrate = migrate;

set = function(params) {
  var VM, xapi;
  VM = extract(params, 'VM');
  xapi = this.getXapi(VM);
  return xapi.editVm(VM._xapiId, params, $coroutine((function(_this) {
    return function*(limits, vm) {
      var error, resourceSet;
      resourceSet = xapi.xo.getData(vm, 'resourceSet');
      if (resourceSet) {
        try {
          return (yield _this.allocateLimitsInResourceSet(limits, resourceSet));
        } catch (error1) {
          error = error1;
          if (!noSuchObject.is(error)) {
            throw error;
          }
        }
      }
      if (limits.cpuWeight && _this.user.permission !== 'admin') {
        throw unauthorized();
      }
    };
  })(this)));
};

set.params = {
  id: {
    type: 'string'
  },
  name_label: {
    type: 'string',
    optional: true
  },
  name_description: {
    type: 'string',
    optional: true
  },
  high_availability: {
    type: 'boolean',
    optional: true
  },
  CPUs: {
    type: 'integer',
    optional: true
  },
  cpusMax: {
    type: ['integer', 'string'],
    optional: true
  },
  memory: {
    type: ['integer', 'string'],
    optional: true
  },
  memoryMin: {
    type: ['integer', 'string'],
    optional: true
  },
  memoryMax: {
    type: ['integer', 'string'],
    optional: true
  },
  memoryStaticMax: {
    type: ['integer', 'string'],
    optional: true
  },
  PV_args: {
    type: 'string',
    optional: true
  },
  cpuWeight: {
    type: ['integer', 'null'],
    optional: true
  },
  cpuCap: {
    type: ['integer', 'null'],
    optional: true
  },
  affinityHost: {
    type: ['string', 'null'],
    optional: true
  }
};

set.resolve = {
  VM: ['id', ['VM', 'VM-snapshot', 'VM-template'], 'administrate']
};

exports.set = set;

restart = $coroutine(function*(arg) {
  var force, vm, xapi;
  vm = arg.vm, force = arg.force;
  xapi = this.getXapi(vm);
  if (force) {
    yield xapi.call('VM.hard_reboot', vm._xapiRef);
  } else {
    yield xapi.call('VM.clean_reboot', vm._xapiRef);
  }
  return true;
});

restart.params = {
  id: {
    type: 'string'
  },
  force: {
    type: 'boolean'
  }
};

restart.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.restart = restart;

clone = $coroutine(function*(arg) {
  var full_copy, name, vm;
  vm = arg.vm, name = arg.name, full_copy = arg.full_copy;
  yield checkPermissionOnSrs.call(this, vm);
  return this.getXapi(vm).cloneVm(vm._xapiRef, {
    nameLabel: name,
    fast: !full_copy
  }).then(function(vm) {
    return vm.$id;
  });
});

clone.params = {
  id: {
    type: 'string'
  },
  name: {
    type: 'string'
  },
  full_copy: {
    type: 'boolean'
  }
};

clone.resolve = {
  vm: ['id', 'VM', 'administrate']
};

exports.clone = clone;

copy = $coroutine(function*(arg) {
  var compress, nameLabel, sr, vm;
  compress = arg.compress, nameLabel = arg.name, sr = arg.sr, vm = arg.vm;
  if (vm.$pool === sr.$pool) {
    if (vm.power_state === 'Running') {
      yield checkPermissionOnSrs.call(this, vm);
    }
    return this.getXapi(vm).copyVm(vm._xapiId, sr._xapiId, {
      nameLabel: nameLabel
    }).then(function(vm) {
      return vm.$id;
    });
  }
  return this.getXapi(vm).remoteCopyVm(vm._xapiId, this.getXapi(sr), sr._xapiId, {
    compress: compress,
    nameLabel: nameLabel
  }).then(function(vm) {
    return vm.$id;
  });
});

copy.params = {
  compress: {
    type: 'boolean',
    optional: true
  },
  name: {
    type: 'string',
    optional: true
  },
  vm: {
    type: 'string'
  },
  sr: {
    type: 'string'
  }
};

copy.resolve = {
  vm: ['vm', ['VM', 'VM-snapshot'], 'administrate'],
  sr: ['sr', 'SR', 'operate']
};

exports.copy = copy;

convertToTemplate = $coroutine(function*(arg) {
  var vm;
  vm = arg.vm;
  if (!(yield this.hasPermissions(this.session.get('user_id'), [[vm.$pool, 'administrate']]))) {
    throw unauthorized();
  }
  yield this.getXapi(vm).call('VM.set_is_a_template', vm._xapiRef, true);
  return true;
});

convertToTemplate.params = {
  id: {
    type: 'string'
  }
};

convertToTemplate.resolve = {
  vm: ['id', ['VM', 'VM-snapshot'], 'administrate']
};

exports.convertToTemplate = convertToTemplate;

exports.convert = convertToTemplate;

snapshot = $coroutine(function*(arg) {
  var name, vm;
  vm = arg.vm, name = arg.name;
  yield checkPermissionOnSrs.call(this, vm);
  snapshot = (yield this.getXapi(vm).snapshotVm(vm._xapiRef, name != null ? name : vm.name_label + "_" + (new Date().toISOString())));
  return snapshot.$id;
});

snapshot.params = {
  id: {
    type: 'string'
  },
  name: {
    type: 'string',
    optional: true
  }
};

snapshot.resolve = {
  vm: ['id', 'VM', 'administrate']
};

exports.snapshot = snapshot;

rollingDeltaBackup = $coroutine(function*(arg) {
  var depth, remote, tag, vm;
  vm = arg.vm, remote = arg.remote, tag = arg.tag, depth = arg.depth;
  return (yield this.rollingDeltaVmBackup({
    vm: vm,
    remoteId: remote,
    tag: tag,
    depth: depth
  }));
});

rollingDeltaBackup.params = {
  id: {
    type: 'string'
  },
  remote: {
    type: 'string'
  },
  tag: {
    type: 'string'
  },
  depth: {
    type: ['string', 'number']
  }
};

rollingDeltaBackup.resolve = {
  vm: ['id', ['VM', 'VM-snapshot'], 'administrate']
};

rollingDeltaBackup.permission = 'admin';

exports.rollingDeltaBackup = rollingDeltaBackup;

importDeltaBackup = function(arg) {
  var filePath, remote, sr;
  sr = arg.sr, remote = arg.remote, filePath = arg.filePath;
  return this.importDeltaVmBackup({
    sr: sr,
    remoteId: remote,
    filePath: filePath
  });
};

importDeltaBackup.params = {
  sr: {
    type: 'string'
  },
  remote: {
    type: 'string'
  },
  filePath: {
    type: 'string'
  }
};

importDeltaBackup.resolve = {
  sr: ['sr', 'SR', 'operate']
};

importDeltaBackup.permission = 'admin';

exports.importDeltaBackup = importDeltaBackup;

deltaCopy = function(arg) {
  var sr, vm;
  vm = arg.vm, sr = arg.sr;
  return this.deltaCopyVm(vm, sr);
};

deltaCopy.params = {
  id: {
    type: 'string'
  },
  sr: {
    type: 'string'
  }
};

deltaCopy.resolve = {
  vm: ['id', 'VM', 'operate'],
  sr: ['sr', 'SR', 'operate']
};

exports.deltaCopy = deltaCopy;

rollingSnapshot = $coroutine(function*(arg) {
  var depth, tag, vm;
  vm = arg.vm, tag = arg.tag, depth = arg.depth;
  yield checkPermissionOnSrs.call(this, vm);
  return (yield this.rollingSnapshotVm(vm, tag, depth));
});

rollingSnapshot.params = {
  id: {
    type: 'string'
  },
  tag: {
    type: 'string'
  },
  depth: {
    type: 'number'
  }
};

rollingSnapshot.resolve = {
  vm: ['id', 'VM', 'administrate']
};

rollingSnapshot.description = 'Snapshots a VM with a tagged name, and removes the oldest snapshot with the same tag according to depth';

exports.rollingSnapshot = rollingSnapshot;

backup = $coroutine(function*(arg) {
  var compress, file, onlyMetadata, remoteId, vm;
  vm = arg.vm, remoteId = arg.remoteId, file = arg.file, compress = arg.compress, onlyMetadata = arg.onlyMetadata;
  return (yield this.backupVm({
    vm: vm,
    remoteId: remoteId,
    file: file,
    compress: compress,
    onlyMetadata: onlyMetadata
  }));
});

backup.permission = 'admin';

backup.params = {
  id: {
    type: 'string'
  },
  remoteId: {
    type: 'string'
  },
  file: {
    type: 'string'
  },
  compress: {
    type: 'boolean',
    optional: true
  },
  onlyMetadata: {
    type: 'boolean',
    optional: true
  }
};

backup.resolve = {
  vm: ['id', 'VM', 'administrate']
};

backup.description = 'Exports a VM to the file system';

exports.backup = backup;

importBackup = function(arg) {
  var file, remote, sr;
  remote = arg.remote, file = arg.file, sr = arg.sr;
  return this.importVmBackup(remote, file, sr);
};

importBackup.permission = 'admin';

importBackup.description = 'Imports a VM into host, from a file found in the chosen remote';

importBackup.params = {
  remote: {
    type: 'string'
  },
  file: {
    type: 'string'
  },
  sr: {
    type: 'string'
  }
};

importBackup.resolve = {
  sr: ['sr', 'SR', 'operate']
};

importBackup.permission = 'admin';

exports.importBackup = importBackup;

rollingBackup = $coroutine(function*(arg) {
  var compress, depth, onlyMetadata, remoteId, tag, vm;
  vm = arg.vm, remoteId = arg.remoteId, tag = arg.tag, depth = arg.depth, compress = arg.compress, onlyMetadata = arg.onlyMetadata;
  return (yield this.rollingBackupVm({
    vm: vm,
    remoteId: remoteId,
    tag: tag,
    depth: depth,
    compress: compress,
    onlyMetadata: onlyMetadata
  }));
});

rollingBackup.permission = 'admin';

rollingBackup.params = {
  id: {
    type: 'string'
  },
  remoteId: {
    type: 'string'
  },
  tag: {
    type: 'string'
  },
  depth: {
    type: 'number'
  },
  compress: {
    type: 'boolean',
    optional: true
  }
};

rollingBackup.resolve = {
  vm: ['id', ['VM', 'VM-snapshot'], 'administrate']
};

rollingBackup.description = 'Exports a VM to the file system with a tagged name, and removes the oldest backup with the same tag according to depth';

exports.rollingBackup = rollingBackup;

rollingDrCopy = function(arg) {
  var depth, pool, sr, tag, vm;
  vm = arg.vm, pool = arg.pool, sr = arg.sr, tag = arg.tag, depth = arg.depth;
  if (!sr) {
    if (!pool) {
      throw invalidParameters('either pool or sr param should be specified');
    }
    if (vm.$pool === pool.id) {
      throw forbiddenOperation('Disaster Recovery attempts to copy on the same pool');
    }
    sr = this.getObject(pool.default_SR, 'SR');
  }
  return this.rollingDrCopyVm({
    vm: vm,
    sr: sr,
    tag: tag,
    depth: depth
  });
};

rollingDrCopy.params = {
  depth: {
    type: 'number'
  },
  id: {
    type: 'string'
  },
  pool: {
    type: 'string',
    optional: true
  },
  sr: {
    type: 'string',
    optional: true
  },
  tag: {
    type: 'string'
  }
};

rollingDrCopy.resolve = {
  vm: ['id', ['VM', 'VM-snapshot'], 'administrate'],
  pool: ['pool', 'pool', 'administrate'],
  sr: ['sr', 'SR', 'administrate']
};

rollingDrCopy.description = 'Copies a VM to a different pool, with a tagged name, and removes the oldest VM with the same tag from this pool, according to depth';

exports.rollingDrCopy = rollingDrCopy;

start = function(arg) {
  var vm;
  vm = arg.vm;
  return this.getXapi(vm).startVm(vm._xapiId);
};

start.params = {
  id: {
    type: 'string'
  }
};

start.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.start = start;

stop = $coroutine(function*(arg) {
  var error, force, vm, xapi;
  vm = arg.vm, force = arg.force;
  xapi = this.getXapi(vm);
  if (force) {
    yield xapi.call('VM.hard_shutdown', vm._xapiRef);
    return true;
  }
  try {
    yield xapi.call('VM.clean_shutdown', vm._xapiRef);
  } catch (error1) {
    error = error1;
    if (error.code === 'VM_MISSING_PV_DRIVERS' || error.code === 'VM_LACKS_FEATURE_SHUTDOWN') {
      throw invalidParameters('clean shutdown requires PV drivers');
    } else {
      throw error;
    }
  }
  return true;
});

stop.params = {
  id: {
    type: 'string'
  },
  force: {
    type: 'boolean',
    optional: true
  }
};

stop.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.stop = stop;

suspend = $coroutine(function*(arg) {
  var vm;
  vm = arg.vm;
  yield this.getXapi(vm).call('VM.suspend', vm._xapiRef);
  return true;
});

suspend.params = {
  id: {
    type: 'string'
  }
};

suspend.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.suspend = suspend;

resume = function(arg) {
  var vm;
  vm = arg.vm;
  return this.getXapi(vm).resumeVm(vm._xapiId);
};

resume.params = {
  id: {
    type: 'string'
  }
};

resume.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.resume = resume;

revert = function(arg) {
  var snapshot, snapshotBefore;
  snapshot = arg.snapshot, snapshotBefore = arg.snapshotBefore;
  return this.getXapi(snapshot).revertVm(snapshot._xapiId, snapshotBefore);
};

revert.params = {
  id: {
    type: 'string'
  },
  snapshotBefore: {
    type: 'boolean',
    optional: true
  }
};

revert.resolve = {
  snapshot: ['id', 'VM-snapshot', 'administrate']
};

exports.revert = revert;

handleExport = $coroutine(function*(req, res, arg) {
  var compress, id, onlyMetadata, ref2, stream, xapi;
  xapi = arg.xapi, id = arg.id, compress = arg.compress, onlyMetadata = arg.onlyMetadata;
  stream = (yield xapi.exportVm(id, {
    compress: compress != null ? compress : true,
    onlyMetadata: onlyMetadata != null ? onlyMetadata : false
  }));
  res.on('close', function() {
    return stream.cancel();
  });
  stream.headers['content-disposition'] = 'attachment';
  res.writeHead(stream.statusCode, (ref2 = stream.statusMessage) != null ? ref2 : '', stream.headers);
  stream.pipe(res);
});

export_ = $coroutine(function*(arg) {
  var compress, data, onlyMetadata, vm;
  vm = arg.vm, compress = arg.compress, onlyMetadata = arg.onlyMetadata;
  if (vm.power_state === 'Running') {
    yield checkPermissionOnSrs.call(this, vm);
  }
  data = {
    xapi: this.getXapi(vm),
    id: vm._xapiId,
    compress: compress,
    onlyMetadata: onlyMetadata
  };
  return {
    $getFrom: (yield this.registerHttpRequest(handleExport, data, {
      suffix: encodeURI("/" + vm.name_label + ".xva")
    }))
  };
});

export_.params = {
  vm: {
    type: 'string'
  },
  compress: {
    type: 'boolean',
    optional: true
  },
  onlyMetadata: {
    type: 'boolean',
    optional: true
  }
};

export_.resolve = {
  vm: ['vm', ['VM', 'VM-snapshot'], 'administrate']
};

exports["export"] = export_;

handleVmImport = $coroutine(function*(req, res, arg) {
  var data, e, srId, type, vm, xapi;
  data = arg.data, srId = arg.srId, type = arg.type, xapi = arg.xapi;
  req.setTimeout(43200000);
  try {
    vm = (yield xapi.importVm(req, {
      data: data,
      srId: srId,
      type: type
    }));
    res.end(format.response(0, vm.$id));
  } catch (error1) {
    e = error1;
    res.writeHead(500);
    res.end(format.error(0, new Error(e.message)));
  }
});

import_ = $coroutine(function*(arg) {
  var data, host, sr, type, xapi;
  data = arg.data, host = arg.host, sr = arg.sr, type = arg.type;
  if (data && type === 'xva') {
    throw invalidParameters('unsupported field data for the file type xva');
  }
  if (!sr) {
    if (!host) {
      throw invalidParameters('you must provide either host or SR');
    }
    xapi = this.getXapi(host);
    sr = xapi.pool.$default_SR;
    if (!sr) {
      throw invalidParameters('there is not default SR in this pool');
    }
  } else {
    xapi = this.getXapi(sr);
  }
  return {
    $sendTo: (yield this.registerHttpRequest(handleVmImport, {
      data: data,
      srId: sr._xapiId,
      type: type,
      xapi: xapi
    }))
  };
});

import_.params = {
  data: {
    type: 'object',
    optional: true,
    properties: {
      descriptionLabel: {
        type: 'string'
      },
      disks: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            capacity: {
              type: 'integer'
            },
            descriptionLabel: {
              type: 'string'
            },
            nameLabel: {
              type: 'string'
            },
            path: {
              type: 'string'
            },
            position: {
              type: 'integer'
            }
          }
        },
        optional: true
      },
      memory: {
        type: 'integer'
      },
      nameLabel: {
        type: 'string'
      },
      nCpus: {
        type: 'integer'
      },
      networks: {
        type: 'array',
        items: {
          type: 'string'
        },
        optional: true
      }
    }
  },
  host: {
    type: 'string',
    optional: true
  },
  type: {
    type: 'string',
    optional: true
  },
  sr: {
    type: 'string',
    optional: true
  }
};

import_.resolve = {
  host: ['host', 'host', 'administrate'],
  sr: ['sr', 'SR', 'administrate']
};

exports["import"] = import_;

attachDisk = $coroutine(function*(arg) {
  var bootable, mode, position, vdi, vm;
  vm = arg.vm, vdi = arg.vdi, position = arg.position, mode = arg.mode, bootable = arg.bootable;
  yield this.getXapi(vm).attachVdiToVm(vdi._xapiId, vm._xapiId, {
    bootable: bootable,
    position: position,
    readOnly: mode === 'RO'
  });
});

attachDisk.params = {
  bootable: {
    type: 'boolean',
    optional: true
  },
  mode: {
    type: 'string',
    optional: true
  },
  position: {
    type: 'string',
    optional: true
  },
  vdi: {
    type: 'string'
  },
  vm: {
    type: 'string'
  }
};

attachDisk.resolve = {
  vm: ['vm', 'VM', 'administrate'],
  vdi: ['vdi', 'VDI', 'administrate']
};

exports.attachDisk = attachDisk;

createInterface = $coroutine(function*(arg) {
  var allowedIpv4Addresses, allowedIpv6Addresses, ipAddresses, mac, network, position, push, vif, vm;
  vm = arg.vm, network = arg.network, position = arg.position, mac = arg.mac, allowedIpv4Addresses = arg.allowedIpv4Addresses, allowedIpv6Addresses = arg.allowedIpv6Addresses;
  vif = (yield this.getXapi(vm).createVif(vm._xapiId, network._xapiId, {
    mac: mac,
    position: position,
    ipv4_allowed: allowedIpv4Addresses,
    ipv6_allowed: allowedIpv6Addresses
  }));
  push = (ipAddresses = []).push;
  if (allowedIpv4Addresses) {
    push.apply(ipAddresses, allowedIpv4Addresses);
  }
  if (allowedIpv6Addresses) {
    push.apply(ipAddresses, allowedIpv6Addresses);
  }
  if (ipAddresses.length) {
    pCatch.call(this.allocIpAddresses(vif.$id, allo), noop);
  }
  return vif.$id;
});

createInterface.params = {
  vm: {
    type: 'string'
  },
  network: {
    type: 'string'
  },
  position: {
    type: ['integer', 'string'],
    optional: true
  },
  mac: {
    type: 'string',
    optional: true
  },
  allowedIpv4Addresses: {
    type: 'array',
    items: {
      type: 'string'
    },
    optional: true
  },
  allowedIpv6Addresses: {
    type: 'array',
    items: {
      type: 'string'
    },
    optional: true
  }
};

createInterface.resolve = {
  vm: ['vm', 'VM', 'administrate'],
  network: ['network', 'network', 'view']
};

exports.createInterface = createInterface;

attachPci = $coroutine(function*(arg) {
  var pciId, vm, xapi;
  vm = arg.vm, pciId = arg.pciId;
  xapi = this.getXapi(vm);
  yield xapi.call('VM.add_to_other_config', vm._xapiRef, 'pci', pciId);
  return true;
});

attachPci.params = {
  vm: {
    type: 'string'
  },
  pciId: {
    type: 'string'
  }
};

attachPci.resolve = {
  vm: ['vm', 'VM', 'administrate']
};

exports.attachPci = attachPci;

detachPci = $coroutine(function*(arg) {
  var vm, xapi;
  vm = arg.vm;
  xapi = this.getXapi(vm);
  yield xapi.call('VM.remove_from_other_config', vm._xapiRef, 'pci');
  return true;
});

detachPci.params = {
  vm: {
    type: 'string'
  }
};

detachPci.resolve = {
  vm: ['vm', 'VM', 'administrate']
};

exports.detachPci = detachPci;

stats = $coroutine(function*(arg) {
  var granularity, vm;
  vm = arg.vm, granularity = arg.granularity;
  stats = (yield this.getXapiVmStats(vm, granularity));
  return stats;
});

stats.description = 'returns statistics about the VM';

stats.params = {
  id: {
    type: 'string'
  },
  granularity: {
    type: 'string',
    optional: true
  }
};

stats.resolve = {
  vm: ['id', ['VM', 'VM-snapshot'], 'view']
};

exports.stats = stats;

setBootOrder = $coroutine(function*(arg) {
  var order, vm, xapi;
  vm = arg.vm, order = arg.order;
  xapi = this.getXapi(vm);
  order = {
    order: order
  };
  if (vm.virtualizationMode === 'hvm') {
    yield xapi.call('VM.set_HVM_boot_params', vm._xapiRef, order);
    return true;
  }
  throw invalidParameters('You can only set the boot order on a HVM guest');
});

setBootOrder.params = {
  vm: {
    type: 'string'
  },
  order: {
    type: 'string'
  }
};

setBootOrder.resolve = {
  vm: ['vm', 'VM', 'operate']
};

exports.setBootOrder = setBootOrder;

recoveryStart = function(arg) {
  var vm;
  vm = arg.vm;
  return this.getXapi(vm).startVmOnCd(vm._xapiId);
};

recoveryStart.params = {
  id: {
    type: 'string'
  }
};

recoveryStart.resolve = {
  vm: ['id', 'VM', 'operate']
};

exports.recoveryStart = recoveryStart;

getCloudInitConfig = $coroutine(function*(arg) {
  var template;
  template = arg.template;
  return (yield this.getXapi(template).getCloudInitConfig(template._xapiId));
});

getCloudInitConfig.params = {
  template: {
    type: 'string'
  }
};

getCloudInitConfig.resolve = {
  template: ['template', 'VM-template', 'administrate']
};

exports.getCloudInitConfig = getCloudInitConfig;

createCloudInitConfigDrive = $coroutine(function*(arg) {
  var config, coreos, sr, vm, xapi;
  vm = arg.vm, sr = arg.sr, config = arg.config, coreos = arg.coreos;
  xapi = this.getXapi(vm);
  if (coreos) {
    yield xapi.createCoreOsCloudInitConfigDrive(vm._xapiId, sr._xapiId, config);
  } else {
    yield xapi.createCloudInitConfigDrive(vm._xapiId, sr._xapiId, config);
  }
  return true;
});

createCloudInitConfigDrive.params = {
  vm: {
    type: 'string'
  },
  sr: {
    type: 'string'
  },
  config: {
    type: 'string'
  }
};

createCloudInitConfigDrive.resolve = {
  vm: ['vm', 'VM', 'administrate'],
  sr: ['sr', 'SR', '']
};

exports.createCloudInitConfigDrive = createCloudInitConfigDrive;

Object.defineProperty(exports, '__esModule', {
  value: true
});
